import {GG_ID} from 'envs/_current/config'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useState} from 'react'
import {LoginSocialGoogle,} from 'reactjs-social-login';
import {FcGoogle} from "react-icons/fc";
import {renderIfElse} from "../../Shared";
import classNames from "classnames";
import {Spin} from "antd";

export default function GoogleLoginBtn({
                                           onSuccess,
                                           label = 'Sign in with Google',
                                           renderButton,
                                       }) {
    const t = useTranslate()
    const [loading, setLoading] = useState(false);

    const onLoginStart = useCallback(() => {
        setLoading(true);
    }, []);


    const onLoginSuccess = useCallback(({provider, data}) => {
        if (data && data.access_token) {
            onSuccess({
                token: data.access_token,
                provider: provider
            });
        }
        setTimeout(() => {
            setLoading(false);
        }, 500)
    }, [onSuccess]);

    const onLoginFailure = useCallback((err) => {
        setLoading(false);
        console.log('Login failed:', err);
    }, []);

    return (
        <React.Fragment>
            <LoginSocialGoogle
                client_id={GG_ID}
                onLoginStart={onLoginStart}
                // redirect_uri={ROOT_URL}
                typeResponse="accessToken"
                scope="openid profile email"
                discoveryDocs="claims_supported"
                onResolve={onLoginSuccess}
                onReject={onLoginFailure}>
                {renderIfElse(
                    renderButton,
                    renderButton,
                    <button
                        style={{
                            minHeight: 44, // Chiều cao tối thiểu theo hướng dẫn của Apple
                            fontSize: 15, // Kích thước chữ chuẩn của Apple
                            fontWeight: '500', // Semibold theo Apple (Tailwind's font-semibold is 600)
                            fontFamily: 'SF Pro Text, SF Pro Display, SF Pro Icons, Helvetica Neue, Helvetica, Arial, sans-serif', // Font chữ ưu tiên của Apple
                            letterSpacing: '0.03em', // Khoảng cách chữ nhẹ
                        }}
                        className="w-full flex flex-center gap-3 background border border-color-100 rounded-lg hover:shadow hover:scale-2xs cursor-pointer">
                        <FcGoogle size={17}/>
                        <span className={classNames("tracking-wide leading-none", loading ? "text-color-300 italic" : "text-gray-700")}>
                        {loading ? t('logging in...') : t(label)}</span>
                        {loading && <Spin spinning/>}
                    </button>
                )}
            </LoginSocialGoogle>

            {/*<LoadingSpin visible={loading} text={t("Signing in with Google…")}/>*/}
        </React.Fragment>
    )
}
